import { AxiosResponse } from 'axios';
import client from 'api/client';
import { CreateTicketPayload } from 'api/models/payload/Ticket';
import { EditTicketPayload } from 'api/models/payload/Ticket';
import { Ticket } from 'api/models/response/Ticket';
import { TicketInterface } from 'types';

//get all tickets
export const getAllTickets = (): Promise<AxiosResponse<Ticket[]>> => {
    return client.get<Ticket[]>(`/tickets`);
};

export const getTicketsByDocument = (document_id: string): Promise<AxiosResponse<Ticket[]>> => {
    return client.get<Ticket[]>(`/tickets?document_id=${document_id}`);
};

export const getTicketsByApplication = (
    application_id: string
): Promise<AxiosResponse<Ticket[]>> => {
    return client.get<Ticket[]>(`/tickets?application_id=${application_id}`);
};

//get ticket
export const getTicket = (ticket_id: string): Promise<AxiosResponse<Ticket | TicketInterface>> => {
    return client.get<Ticket>(`/ticket/${ticket_id}`);
    // return client.get<Ticket>(`/ticket?ticket_id=${ticket_id}`);
};

//create new ticket
export const createTicket = (
    data: CreateTicketPayload | TicketInterface
): Promise<AxiosResponse<Ticket>> => {
    return client.post<Ticket>(`/ticket`, data);
};

// edit ticket
export const editTicket = (
    data: EditTicketPayload | TicketInterface
): Promise<AxiosResponse<Ticket>> => {
    return client.put<Ticket>(`/ticket`, data);
};

// delete ticket
export const deleteTicket = (ticket_id: string): Promise<AxiosResponse<Ticket>> => {
    return client.delete<Ticket>(`/ticket?ticket_id=${ticket_id}`);
};
